import { Component, OnInit, OnDestroy, Input, AfterViewInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { StudentInfoService } from '../../_services/student-info.service';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { FutureInfoService } from './../../_services/future-info.service';
import {ValidationService} from "../../validation.service";

@Component({
  selector: 'app-calculator-dialog',
  templateUrl: './calculator-dialog.component.html',
  styleUrls: ['./calculator-dialog.component.css'],
  providers: [StudentInfoService, FutureInfoService]
})
export class CalculatorDialogComponent implements OnInit {

  addSchoolForm: FormGroup;
  submitdataSub: Subscription;
  error: boolean;
  errorFlag: boolean;
  successMessage: string;
  errorMessage: string;
  submitBtnText = '';
  submitting: boolean;
  fieldErrors: any;
  public personalEmail: string;
  currentUser: any;
  loading: boolean;
  public objData: any= {};
  public checkChange: boolean;
  public valueChange = false;
  public highschool_id;
  public tution_and_fee;
  public room_and_board;
  public books_and_supply;
  public travel;
  public persnl_exp;
  public cal_grant;
  public schoolarships;
  public fed_dir_loan;
  public coll_uni_aid;
  public other_aid;
  public work_std;
  public fed_per_loan;
  public othr_std_load;

  public numberMask = createNumberMask({
    prefix: '$',
    allowDecimal: true,
    integerLimit: 10
  });

  constructor(private _fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public api: StudentInfoService,
    public futureInfo: FutureInfoService,
    public dialogRef: MatDialogRef<CalculatorDialogComponent>) { }

  ngOnInit() {
    this.createForm();
  }

  createForm() {

    this.addSchoolForm  = this._fb.group({
      clgname: ['', [Validators.required, ValidationService.noSpaceValidator]],
      tutionfees: ['', [Validators.required]],
      roomboard: ['', [Validators.required]],
      booksupplies: ['', [Validators.required]],
      travel: ['', [Validators.required]],
      personalexpenses: ['', [Validators.required]],
      calgrant: ['', [Validators.required]],
      pellgrant:['', [Validators.required]],
      scholarships: ['', [Validators.required]],
      federaldirectloans: ['', [Validators.required]],
      collegeaid: ['', [Validators.required]],
      othergiftaid: ['', [Validators.required]],
      workstudy: ['', [Validators.required]],
      federalperkinsloans: ['', [Validators.required]],
      otherstudentloans: ['', [Validators.required]],
    });
  }

  renderHero = (data: any): SafeHtml => {
    const html = `<span>${data.name}</span>`;
    return html;
  }

  onSubmit() {
    this.objData= JSON.stringify({
        postsecondary_id: this.addSchoolForm.controls.clgname.value.id,
        tution_and_fee: this.addSchoolForm.controls.tutionfees.value.replace(/\,/g, '').replace(/\$/g, ''),
        room_and_board: this.addSchoolForm.controls.roomboard.value.replace(/\,/g, '').replace(/\$/g, ''),
        books_and_supply: this.addSchoolForm.controls.booksupplies.value.replace(/\,/g, '').replace(/\$/g, ''),
        travel: this.addSchoolForm.controls.travel.value.replace(/\,/g, '').replace(/\$/g, ''),
        persnl_exp: this.addSchoolForm.controls.personalexpenses.value.replace(/\,/g, '').replace(/\$/g, ''),
        cal_grant: this.addSchoolForm.controls.calgrant.value.replace(/\,/g, '').replace(/\$/g, ''),
        pell_grant:this.addSchoolForm.controls.pellgrant.value.replace(/\,/g, '').replace(/\$/g, ''),
        schoolarships: this.addSchoolForm.controls.scholarships.value.replace(/\,/g, '').replace(/\$/g, ''),
        fed_dir_loan: this.addSchoolForm.controls.federaldirectloans.value.replace(/\,/g, '').replace(/\$/g, ''),
        coll_uni_aid: this.addSchoolForm.controls.collegeaid.value.replace(/\,/g, '').replace(/\$/g, ''),
        other_aid: this.addSchoolForm.controls.othergiftaid.value.replace(/\,/g, '').replace(/\$/g, ''),
        work_std: this.addSchoolForm.controls.workstudy.value.replace(/\,/g, '').replace(/\$/g, ''),
        fed_per_loan: this.addSchoolForm.controls.federalperkinsloans.value.replace(/\,/g, '').replace(/\$/g, ''),
        othr_std_load: this.addSchoolForm.controls.otherstudentloans.value.replace(/\,/g, '').replace(/\$/g, '')
    });

    console.log(this.objData);
    this.loading = true;
    this.api.postStudentInfo$(this.objData)
    .subscribe(
      data => {
        this.error = false;
        this.errorFlag = false;
        this.loading = false;
        setTimeout(() => {
        }, 2000);
        this.dialogRef.close(data);
      },
      error => {
        this.submitting = false;
        this.errorFlag = true;
        this.loading = false;
        setTimeout(() => {
        }, 2000);
        this.dialogRef.close(error);
      }
    );
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/calculator-dialog/calculator-dialog.component.ts